export default __webpack_public_path__ + "761ea22fb514fae8fbac58d2b42580e5.png";